import { keyBy } from '../../../helpers/common'
import { COLORS_TREND } from '../constant'

export const handleData = (data) =>
  keyBy(
    data.map((item) => ({
      ...item,
      chart: {
        trendColor: COLORS_TREND[item?.trend],
        trendLine: item?.trendline,
      },
      company: {
        name: item?.companyName,
        taxCode: item?.taxCode,
        organizationId: item?.organizationId,
      },
    })),
    'rank',
  )
